import Link from 'next/link'

import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  min-height: 36px;
  text-decoration: none;

  > span {
    color: ${themeGet('colors.text.body')};
  }
`
